export const SET_BENEFIT_TAGS = 'SET_BENEFIT_TAGS';
export const ADD_BENEFIT_TAG = 'ADD_BENEFIT_TAG';
export const EDIT_BENEFIT_TAG = 'EDIT_BENEFIT_TAG';
export const DELETE_BENEFIT_TAG = 'DELETE_BENEFIT_TAG';
